<template>
  <div :class="containerClass">
    <v-text-field
      v-model.lazy="localModel"
      :append-icon="localModel ? 'close' : ''"
      :background-color="backgroundColor"
      :class="{'closed': searchClosed && !localModel && !maximized, 'disabled': disabled}"
      :disabled="disabled"
      :placeholder="$t('Common.Search.Label')"
      class="expanding-search"
      dense
      flat
      hide-details
      prepend-inner-icon="search"
      single-line
      solo
      @focusin="onFocusIn"
      @focusout="onFocusOut"
      @input="(data) => onSearchDebounced(data)"
      @click:append="onClearClick"
    />
  </div>
</template>

<script>

export default {
  name      : 'FilterSearch',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    value: {
      type   : String,
      default: ''
    },

    containerClass: {
      type   : String,
      default: 'ma-1'
    },

    maximized: {
      type   : Boolean,
      default: false
    },

    disabled: {
      type   : Boolean,
      default: false
    },

    size: {
      type   : String,
      default: '48px'
    },

    maxWidth: {
      type   : String,
      default: '350px'
    },

    padding: {
      type   : String,
      default: '0 12px'
    },

    denseSize: {
      type   : String,
      default: '36px'
    },

    denseMaxWidth: {
      type   : String,
      default: '240px'
    },

    densePadding: {
      type   : String,
      default: '0 6px'
    },

    backgroundColor: {
      type   : String,
      default: ''
    }
  },
  enums: {},
  data() {
    return {
      localModel           : '',
      searchClosed         : true,
      debounceSearchTimeout: null
    }
  },
  computed: {
    model: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onClearClick() {
      this.localModel = ''
      this.model = this.localModel
    },
    onFocusIn() {
      this.searchClosed = false
    },
    onFocusOut() {
      this.searchClosed = true
    },

    onSearchDebounced(data) {
      clearTimeout(this.debounceSearchTimeout)
      this.debounceSearchTimeout = setTimeout(() => {
        this.$emit('input', data)
      }, 500)
    }
  }
}
</script>

<style scoped>
.expanding-search {
  width: 100%;
  max-width: v-bind(maxWidth);
  transition: max-width 0.3s;
}

.expanding-search.closed {
  max-width: v-bind(size);
}

:deep(.v-text-field.v-text-field--solo .v-input__control) {
  min-height: v-bind(size);
}

:deep(.v-text-field.v-text-field--enclosed .v-text-field__details),
:deep(.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot) {
  padding: v-bind(padding);
}

:deep(.theme--dark.v-input--is-disabled .v-icon) {
  color: rgba(255, 255, 255, 0.3) !important;
}

:deep(.theme--light.v-input--is-disabled .v-icon) {
  color: rgba(0, 0, 0, 0.26) !important;
}

:deep(.theme--dark.v-input--is-disabled > .v-input__control > .v-input__slot) {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

:deep(.theme--light.v-input--is-disabled > .v-input__control > .v-input__slot) {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

:deep(.theme--light.v-text-field--solo > .v-input__control > .v-input__slot) {
  background: rgba(0, 0, 0, 0.06);
}

:deep(.expanding-search.closed .v-input__control .v-input__slot) {
  cursor: pointer !important;
}

:deep(.v-icon) {
  color: #1976d2;
}

@media only screen and (max-width: 599px) {
  .expanding-search {
    max-width: v-bind(denseMaxWidth);
  }

  .expanding-search.closed {
    max-width: v-bind(denseSize);
  }

  :deep(.v-text-field.v-text-field--solo .v-input__control) {
    min-height: v-bind(denseSize);
  }

  :deep(.v-text-field.v-text-field--enclosed .v-text-field__details),
  :deep(.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot) {
    padding: v-bind(densePadding);
  }
}
</style>
